import { render, staticRenderFns } from "./CreateIncident.vue?vue&type=template&id=84666c12"
import script from "./CreateIncident.vue?vue&type=script&lang=js"
export * from "./CreateIncident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports